<template>
  <div class="screen page products b-soft">
    <div class="grid">
      <section class="layout">
        <div class="container">
          <div class="row h-items-center">
            <div class="col-12 box-container b-white moves-container no-select">
              <ul v-if="productos.length" class="list-container container">
                <li v-for="producto in productos" :key="producto.id" class="row v-items-center">
                  <div class="col" v-on:click.prevent="goTo('/producto/'+producto.id)">
                    <div class="container">
                      <div class="row v-items-center">
                        <div class="col-auto">
                          <span class="icon-list" v-bind:style="{'background-color': producto.color}">
                            <b class="t-18-px">{{producto.nombre | initialText}}</b>
                          </span>
                        </div>
                        <div class="col">
                          <p class="t-complementary t-14-px">
                            <span>{{producto.nombre | cutText}}</span>
                            <br>
                            <span class="t-upper t-10-px t-base" v-if="producto.fecha_creacion">Creado: {{producto.fecha_creacion.seconds | beautyFormatDate}}</span> <span class="t-upper t-10-px t-base" v-if="producto.usuario_creador"> Por {{producto.usuario_creador}}</span><span class="t-upper t-10-px t-base separador-fechas" v-if="producto.fecha_creacion && producto.fecha_modificacion"> / </span><span class="t-upper t-10-px t-base" v-if="producto.fecha_modificacion">Editado: {{producto.fecha_modificacion.seconds | beautyFormatDate}}</span> <span class="t-upper t-10-px t-base" v-if="producto.usuario_editor"> Por {{producto.usuario_editor}}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-auto">
                    <a href="#" class="t-complementary" v-on:click.prevent="deleteElement('productos', producto.id)">
                      <i class="fa fa-trash"></i>
                    </a>
                  </div>
                 </li>
              </ul>
              <p v-else class="t-center">
                <i class="fas fa-sad-cry t-48-px"></i>
                <br>
                <br>
                No se encontraron productos
              </p>
            </div>
          </div>
        </div>
      </section>
      <GetFooter />
    </div>
  </div>
</template>

<script>
import GetFooter from '@/components/footer.vue'
import router from '@/router'
import { db } from '@/firebase'
export default {
  name: 'app',
  components: {
    GetFooter
  },
  data() {
    return {
      productos: []
    }
  },
  firestore () {
    return {
      productos: db.collection('productos').orderBy('fecha_modificacion', 'desc')
    }
  },
  methods: {
    goTo (url){
      router.push({path: url})
    },
    deleteElement(collection, id){
      if(window.confirm('¿Estás Seguro? Esto eliminará el elemento permanentemente.')){
        db.collection(collection).doc(id).delete().then(function() {
          console.log('Document successfully deleted!')
        }).catch(function(error) {
          alert('Error de ejecución')
          console.error('Error removing document: ', error)
        })
      }
    }
  }
}
</script>